import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import PrintIcon from "@mui/icons-material/Print";
import SaveIcon from "@mui/icons-material/Save";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { deleteObject, getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useHistory, useParams } from "react-router-dom";
import { db, storage } from "../Config/firebase";
import Navbar from "../Components/Navbar/navbar";
import { compressImage } from "../../utils/compressImage";
import RelatorioVisitaTecnicaPrint from "./RelatorioVisitaTecnicaPrint";
import { atualizarTextosPadraoLegados, textosPadraoSimplesVisita } from "./CadastroVisitaTecnica";
import "../CadastroExtracoes/DetalhesExtracao.css";
import { atualizarDocumentoComMesclagem } from "../Utils/concorrenciaFirestore";

function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = dataISO.split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function novaLinhaParecer(local = "") {
  return {
    local,
    naoConformidade: "",
    tratamento: "",
    fotosParecer: [],
  };
}

function normalizarFotoRelatorio(foto, index) {
  return {
    id: foto.id || `foto-${index + 1}`,
    legenda: limparLegendaFoto(foto.legenda || ""),
    url: foto.url || "",
    path: foto.path || "",
    nomeArquivo: foto.nomeArquivo || "",
  };
}

function limparLegendaFoto(legenda) {
  return String(legenda || "")
    .trim()
    .replace(/^foto\s*\d+\s*[-–:]?\s*/i, "")
    .trim();
}

function removerNumeracaoTitulo(texto) {
  return String(texto || "").replace(/^\d+(?:\.\d+)*\.\s*/, "");
}

function fotosComMinimo(relatorio) {
  const fotos = Array.isArray(relatorio?.relatorioFotografico) ? relatorio.relatorioFotografico : [];
  return fotos.length
    ? fotos.map(normalizarFotoRelatorio)
    : [
        {
          id: "foto-1",
          legenda: "",
          url: "",
          path: "",
          nomeArquivo: "",
        },
      ];
}

function fotosParecerComMinimo(item) {
  const fotos = Array.isArray(item?.fotosParecer) ? item.fotosParecer : [];
  return fotos.length
    ? fotos.map(normalizarFotoRelatorio)
    : [
        {
          id: "foto-parecer-1",
          legenda: item?.local || "",
          url: "",
          path: "",
          nomeArquivo: "",
        },
      ];
}

function montarFotosRelatorioOrdenadas(relatorio) {
  const fotosParecer = (relatorio?.parecerItens || []).flatMap((item, itemIndex) =>
    (Array.isArray(item.fotosParecer) ? item.fotosParecer : [])
      .filter((foto) => foto?.url)
      .map((foto, fotoIndex) => ({
        ...foto,
        id: foto.id || `parecer-${itemIndex + 1}-${fotoIndex + 1}`,
        legenda: limparLegendaFoto(foto.legenda || item.local || ""),
      }))
  );
  const fotosGerais = (relatorio?.relatorioFotografico || []).filter((foto) => foto?.url);
  return [...fotosParecer, ...fotosGerais];
}

function obterExtensaoImagem(arquivo) {
  const extensaoNome = arquivo?.name?.split(".").pop()?.toLowerCase();
  if (extensaoNome) return extensaoNome;
  if (arquivo?.type?.includes("/")) return arquivo.type.split("/").pop().toLowerCase();
  return "jpg";
}

function obterTipoImagem(arquivo, extensao) {
  if (arquivo?.type?.startsWith("image/")) return arquivo.type;
  if (extensao === "jpg" || extensao === "jpeg") return "image/jpeg";
  if (extensao === "png") return "image/png";
  if (extensao === "webp") return "image/webp";
  if (extensao === "gif") return "image/gif";
  return "image/jpeg";
}

const inputTabelaSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
  },
  "& .MuiInputBase-input, & .MuiInputBase-inputMultiline": {
    fontSize: 13,
  },
};

export default function DetalhesVisitaTecnica() {
  const { visitaTecnicaId } = useParams();
  const history = useHistory();
  const [relatorio, setRelatorio] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [modoPrint, setModoPrint] = useState(false);
  const [temAlteracoes, setTemAlteracoes] = useState(false);
  const [openConfirmarCancelamento, setOpenConfirmarCancelamento] = useState(false);
  const [openFotos, setOpenFotos] = useState(false);
  const [openFotosParecer, setOpenFotosParecer] = useState(false);
  const [uploadingFotoIndex, setUploadingFotoIndex] = useState(null);
  const [fotosDraft, setFotosDraft] = useState([]);
  const [fotosParecerDraft, setFotosParecerDraft] = useState([]);
  const [parecerFotoIndex, setParecerFotoIndex] = useState(null);
  const [navegacaoPendente, setNavegacaoPendente] = useState(null);
  const desbloquearNavegacaoRef = useRef(null);
  const relatorioOriginalRef = useRef(null);

  useEffect(() => {
    carregarRelatorio();
  }, [visitaTecnicaId]);

  useEffect(() => {
    function confirmarSaida(event) {
      if (!temAlteracoes) return;
      event.preventDefault();
      event.returnValue = "";
    }

    window.addEventListener("beforeunload", confirmarSaida);
    return () => window.removeEventListener("beforeunload", confirmarSaida);
  }, [temAlteracoes]);

  useEffect(() => {
    if (!temAlteracoes) return undefined;

    desbloquearNavegacaoRef.current = history.block((location) => {
      setNavegacaoPendente(location);
      setOpenConfirmarCancelamento(true);
      return false;
    });

    return () => {
      desbloquearNavegacaoRef.current?.();
      desbloquearNavegacaoRef.current = null;
    };
  }, [history, temAlteracoes]);

  async function carregarRelatorio() {
    const snap = await getDoc(doc(db, "tblRelatoriosVisitaTecnica", visitaTecnicaId));
    if (!snap.exists()) return;

    const dados = { id: snap.id, ...snap.data() };
    const dadosAtualizados = atualizarTextosPadraoLegados(dados);

    const relatorioCarregado = {
      ...textosPadraoSimplesVisita,
      ...dadosAtualizados,
      parecerItens: Array.isArray(dadosAtualizados.parecerItens) && dadosAtualizados.parecerItens.length
        ? dadosAtualizados.parecerItens
        : [novaLinhaParecer()],
      notasParecer: Array.isArray(dadosAtualizados.notasParecer) ? dadosAtualizados.notasParecer : [""],
    };
    setRelatorio(relatorioCarregado);
    relatorioOriginalRef.current = relatorioCarregado;
    setTemAlteracoes(false);
    setOpenConfirmarCancelamento(false);
  }

  function atualizarCampo(campo, valor) {
    setMensagem("");
    setTemAlteracoes(true);
    setRelatorio((prev) => ({ ...prev, [campo]: valor }));
  }

  function atualizarLinhaParecer(index, campo, valor) {
    setMensagem("");
    setTemAlteracoes(true);
    setRelatorio((prev) => ({
      ...prev,
      parecerItens: prev.parecerItens.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [campo]: valor } : item
      ),
    }));
  }

  function adicionarLinhaParecerNoLocal(index) {
    setMensagem("");
    setTemAlteracoes(true);
    setRelatorio((prev) => {
      const itens = prev.parecerItens || [];
      const local = itens[index]?.local || "";
      let posicaoInsercao = index + 1;

      while (posicaoInsercao < itens.length && (itens[posicaoInsercao]?.local || "") === local) {
        posicaoInsercao += 1;
      }

      return {
        ...prev,
        parecerItens: [
          ...itens.slice(0, posicaoInsercao),
          novaLinhaParecer(local),
          ...itens.slice(posicaoInsercao),
        ],
      };
    });
  }

  function adicionarLocalParecer() {
    setMensagem("");
    setTemAlteracoes(true);
    setRelatorio((prev) => ({
      ...prev,
      parecerItens: [...(prev.parecerItens || []), novaLinhaParecer()],
    }));
  }

  function removerLinhaParecer(index) {
    setMensagem("");
    setTemAlteracoes(true);
    setRelatorio((prev) => ({
      ...prev,
      parecerItens: prev.parecerItens.filter((_, itemIndex) => itemIndex !== index),
    }));
  }

  function atualizarNota(index, valor) {
    setMensagem("");
    setTemAlteracoes(true);
    setRelatorio((prev) => ({
      ...prev,
      notasParecer: prev.notasParecer.map((nota, itemIndex) => (itemIndex === index ? valor : nota)),
    }));
  }

  function adicionarNota() {
    setMensagem("");
    setTemAlteracoes(true);
    setRelatorio((prev) => ({ ...prev, notasParecer: [...(prev.notasParecer || []), ""] }));
  }

  function removerNota(index) {
    setMensagem("");
    setTemAlteracoes(true);
    setRelatorio((prev) => ({
      ...prev,
      notasParecer: prev.notasParecer.filter((_, itemIndex) => itemIndex !== index),
    }));
  }

  function abrirCadastroFotos() {
    setFotosDraft(fotosComMinimo(relatorio).map((foto) => ({ ...foto })));
    setOpenFotos(true);
  }

  function adicionarFotoExtra() {
    setFotosDraft((prev) => [
      ...prev,
      {
        id: `foto-${Date.now()}`,
        legenda: "",
        url: "",
        path: "",
        nomeArquivo: "",
      },
    ]);
  }

  function selecionarImagemFoto(index, arquivo) {
    if (!arquivo) return;

    const previewUrl = URL.createObjectURL(arquivo);
    setFotosDraft((prev) =>
      prev.map((foto, itemIndex) =>
        itemIndex === index
          ? {
              ...foto,
              arquivo,
              previewUrl,
              nomeArquivo: arquivo.name,
            }
          : foto
      )
    );
  }

  function atualizarLegendaFoto(index, legenda) {
    setFotosDraft((prev) => prev.map((foto, itemIndex) => (itemIndex === index ? { ...foto, legenda } : foto)));
  }

  function removerImagemFoto(index) {
    setFotosDraft((prev) =>
      prev.map((foto, itemIndex) =>
        itemIndex === index
          ? {
              ...foto,
              url: "",
              path: "",
              arquivo: null,
              previewUrl: "",
              nomeArquivo: "",
              removerPath: foto.path || foto.removerPath || "",
            }
          : foto
      )
    );
  }

  function abrirCadastroFotosParecer(index) {
    const item = relatorio.parecerItens?.[index] || {};
    setParecerFotoIndex(index);
    setFotosParecerDraft(fotosParecerComMinimo(item).map((foto) => ({ ...foto })));
    setOpenFotosParecer(true);
  }

  function adicionarFotoParecerExtra() {
    const item = relatorio.parecerItens?.[parecerFotoIndex] || {};
    setFotosParecerDraft((prev) => [
      ...prev,
      {
        id: `foto-parecer-${Date.now()}`,
        legenda: item.local || "",
        url: "",
        path: "",
        nomeArquivo: "",
      },
    ]);
  }

  function selecionarImagemFotoParecer(index, arquivo) {
    if (!arquivo) return;

    const previewUrl = URL.createObjectURL(arquivo);
    setFotosParecerDraft((prev) =>
      prev.map((foto, itemIndex) =>
        itemIndex === index
          ? {
              ...foto,
              arquivo,
              previewUrl,
              nomeArquivo: arquivo.name,
            }
          : foto
      )
    );
  }

  function atualizarLegendaFotoParecer(index, legenda) {
    setFotosParecerDraft((prev) =>
      prev.map((foto, itemIndex) => (itemIndex === index ? { ...foto, legenda } : foto))
    );
  }

  function removerImagemFotoParecer(index) {
    setFotosParecerDraft((prev) =>
      prev.map((foto, itemIndex) =>
        itemIndex === index
          ? {
              ...foto,
              url: "",
              path: "",
              arquivo: null,
              previewUrl: "",
              nomeArquivo: "",
              removerPath: foto.path || foto.removerPath || "",
            }
          : foto
      )
    );
  }

  async function salvarFotos() {
    if (!relatorio?.id) return;
    setUploadingFotoIndex(-1);

    try {
      const fotosSalvas = [];

      for (let index = 0; index < fotosDraft.length; index++) {
        const foto = fotosDraft[index];
        let fotoFinal = {
          id: foto.id || `foto-${index + 1}`,
          legenda: limparLegendaFoto(foto.legenda || ""),
          url: foto.url || "",
          path: foto.path || "",
          nomeArquivo: foto.nomeArquivo || "",
        };

        if (foto.arquivo) {
          let arquivoUpload = foto.arquivo;
          let extensao = obterExtensaoImagem(foto.arquivo);
          let contentType = obterTipoImagem(foto.arquivo, extensao);

          try {
            arquivoUpload = await compressImage(foto.arquivo, {
              maxWidth: 1400,
              maxHeight: 1400,
              quality: 0.72,
            });
            extensao = "jpg";
            contentType = "image/jpeg";
          } catch (error) {
            console.warn("Imagem mantida no formato original:", error);
          }

          const caminho = `visitas-tecnicas/${relatorio.id}/relatorio-fotografico/foto-${index + 1}-${Date.now()}.${extensao}`;
          const storageRef = ref(storage, caminho);
          await uploadBytes(storageRef, arquivoUpload, { contentType });
          const url = await getDownloadURL(storageRef);

          if (foto.path) {
            deleteObject(ref(storage, foto.path)).catch(() => {});
          }

          fotoFinal = {
            ...fotoFinal,
            url,
            path: caminho,
            nomeArquivo: foto.arquivo.name,
          };
        } else if (foto.removerPath) {
          deleteObject(ref(storage, foto.removerPath)).catch(() => {});
        }

        fotosSalvas.push(fotoFinal);
      }

      await updateDoc(doc(db, "tblRelatoriosVisitaTecnica", relatorio.id), {
        relatorioFotografico: fotosSalvas,
        atualizadoEm: new Date(),
      });

      setRelatorio((prev) => ({ ...prev, relatorioFotografico: fotosSalvas }));
      relatorioOriginalRef.current = {
        ...relatorioOriginalRef.current,
        relatorioFotografico: fotosSalvas,
      };
      setFotosDraft([]);
      setOpenFotos(false);
      setMensagem("Relatório fotográfico salvo com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar relatório fotográfico:", error);
      const mensagemErro = error?.message || "Não foi possível salvar as imagens do relatório fotográfico.";
      setMensagem(`Erro ao salvar relatório fotográfico: ${mensagemErro}`);
    } finally {
      setUploadingFotoIndex(null);
    }
  }

  async function salvarFotosParecer() {
    if (!relatorio?.id || parecerFotoIndex === null) return;
    setUploadingFotoIndex(-1);

    try {
      const fotosSalvas = [];
      const itemParecer = relatorio.parecerItens?.[parecerFotoIndex] || {};

      for (let index = 0; index < fotosParecerDraft.length; index++) {
        const foto = fotosParecerDraft[index];
        let fotoFinal = {
          id: foto.id || `foto-parecer-${parecerFotoIndex + 1}-${index + 1}`,
          legenda: limparLegendaFoto(foto.legenda || ""),
          url: foto.url || "",
          path: foto.path || "",
          nomeArquivo: foto.nomeArquivo || "",
        };

        if (foto.arquivo) {
          let arquivoUpload = foto.arquivo;
          let extensao = obterExtensaoImagem(foto.arquivo);
          let contentType = obterTipoImagem(foto.arquivo, extensao);

          try {
            arquivoUpload = await compressImage(foto.arquivo, {
              maxWidth: 1400,
              maxHeight: 1400,
              quality: 0.72,
            });
            extensao = "jpg";
            contentType = "image/jpeg";
          } catch (error) {
            console.warn("Imagem mantida no formato original:", error);
          }

          const caminho = `visitas-tecnicas/${relatorio.id}/relatorio-fotografico/parecer-item-${parecerFotoIndex + 1}-foto-${index + 1}-${Date.now()}.${extensao}`;
          const storageRef = ref(storage, caminho);
          await uploadBytes(storageRef, arquivoUpload, { contentType });
          const url = await getDownloadURL(storageRef);

          if (foto.path) {
            deleteObject(ref(storage, foto.path)).catch(() => {});
          }

          fotoFinal = {
            ...fotoFinal,
            url,
            path: caminho,
            nomeArquivo: foto.arquivo.name,
          };
        } else if (foto.removerPath) {
          deleteObject(ref(storage, foto.removerPath)).catch(() => {});
        }

        if (fotoFinal.url) {
          fotosSalvas.push(fotoFinal);
        }
      }

      const parecerItensAtualizados = (relatorio.parecerItens || []).map((item, index) =>
        index === parecerFotoIndex
          ? {
              ...item,
              local: item.local || itemParecer.local || "",
              fotosParecer: fotosSalvas,
            }
          : item
      );

      await updateDoc(doc(db, "tblRelatoriosVisitaTecnica", relatorio.id), {
        parecerItens: parecerItensAtualizados,
        atualizadoEm: new Date(),
      });

      setRelatorio((prev) => ({ ...prev, parecerItens: parecerItensAtualizados }));
      relatorioOriginalRef.current = {
        ...relatorioOriginalRef.current,
        parecerItens: parecerItensAtualizados,
      };
      setFotosParecerDraft([]);
      setParecerFotoIndex(null);
      setOpenFotosParecer(false);
      setMensagem("Fotos do parecer salvas com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar fotos do parecer:", error);
      const mensagemErro = error?.message || "Não foi possível salvar as fotos do parecer.";
      setMensagem(`Erro ao salvar fotos do parecer: ${mensagemErro}`);
    } finally {
      setUploadingFotoIndex(null);
    }
  }

  async function salvarTudo() {
    setMensagem("");
    setSalvando(true);

    try {
      const salvo = await atualizarDocumentoComMesclagem({
        db,
        referencia: doc(db, "tblRelatoriosVisitaTecnica", visitaTecnicaId),
        original: relatorioOriginalRef.current,
        atual: relatorio,
        preparar: (estado) => {
          const preparado = { ...estado };
          delete preparado.id;
          return preparado;
        },
        metadados: { atualizadoEm: new Date() },
      });
      const salvoTela = { ...salvo, id: visitaTecnicaId };
      setRelatorio(salvoTela);
      relatorioOriginalRef.current = salvoTela;

      setTemAlteracoes(false);
      setMensagem("Salvo com sucesso!");
    } catch (error) {
      console.error(error);
      setMensagem("Erro ao salvar dados.");
    } finally {
      setSalvando(false);
    }
  }

  function visualizarRelatorio() {
    setModoPrint(true);
  }

  function solicitarCancelarAlteracoes() {
    setNavegacaoPendente(null);
    setOpenConfirmarCancelamento(true);
  }

  async function confirmarCancelarAlteracoes() {
    setOpenConfirmarCancelamento(false);
    await carregarRelatorio();

    if (navegacaoPendente) {
      const destino = `${navegacaoPendente.pathname}${navegacaoPendente.search || ""}${navegacaoPendente.hash || ""}`;
      desbloquearNavegacaoRef.current?.();
      desbloquearNavegacaoRef.current = null;
      setNavegacaoPendente(null);
      history.push(destino);
    }
  }

  if (!relatorio) return null;

  const fotosRelatorio = montarFotosRelatorioOrdenadas(relatorio);
  const numeroParecer = "3";
  const numeroIdentificacaoParecer = `${numeroParecer}.1`;
  const numeroBoasPraticas = `${numeroParecer}.2`;
  const boasPraticasPreenchida = String(relatorio.boasPraticas || "").trim();
  const tituloBoasPraticas = boasPraticasPreenchida ? `${numeroBoasPraticas}. Boas práticas` : "Boas práticas";
  const numeroResultadoAceitacao = boasPraticasPreenchida ? `${numeroParecer}.3` : `${numeroParecer}.2`;
  const numeroAnexos = "4";
  const numeroConsideracoesFinais = "5";

  if (modoPrint) {
    return (
      <RelatorioVisitaTecnicaPrint
        relatorio={relatorio}
        fotosRelatorio={fotosRelatorio.filter((foto) => foto.url)}
        onVoltar={() => setModoPrint(false)}
      />
    );
  }

  return (
    <>
      <Navbar />

      <Box className="extracao-actions">
        <Box className="extracao-actions-titulos">
          <Typography component="h1">Relatório de Visita Técnica</Typography>
          <Typography component="p">
            {relatorio.codigo || "RE-VT"}&nbsp;&nbsp; Rev.00 - {formatarDataBR(relatorio.dataRelatorio)}
          </Typography>
        </Box>

        <Box className="extracao-actions-botoes">
          {temAlteracoes ? (
            <>
              <Tooltip title="Visualizar relatório">
                <span>
                  <IconButton color="primary" disabled aria-label="Visualizar relatório">
                    <VisibilityIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Relatório fotográfico">
                <span>
                  <IconButton color="primary" disabled aria-label="Relatório fotográfico">
                    <PhotoLibraryIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Imprimir relatório">
                <span>
                  <IconButton color="primary" disabled aria-label="Imprimir relatório">
                    <PrintIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Button variant="outlined" disabled startIcon={<ArrowBackIcon />}>Voltar</Button>
              <Button variant="contained" onClick={salvarTudo} disabled={salvando} startIcon={<SaveIcon />}>
                {salvando ? "Salvando..." : "Salvar"}
              </Button>
              <Button data-confirmacao-cancelamento="propria" variant="outlined" onClick={solicitarCancelarAlteracoes} disabled={salvando}>
                Cancelar alterações
              </Button>
            </>
          ) : (
            <>
              <Tooltip title="Visualizar relatório">
                <IconButton color="primary" onClick={visualizarRelatorio} aria-label="Visualizar relatório">
                  <VisibilityIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Relatório fotográfico">
                <IconButton color="primary" onClick={abrirCadastroFotos} aria-label="Relatório fotográfico">
                  <PhotoLibraryIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Imprimir relatório">
                <IconButton color="primary" onClick={visualizarRelatorio} aria-label="Imprimir relatório">
                  <PrintIcon />
                </IconButton>
              </Tooltip>
              <Button variant="outlined" onClick={() => history.goBack()} disabled={salvando} startIcon={<ArrowBackIcon />}>
                Voltar
              </Button>
            </>
          )}
        </Box>
      </Box>

      <Box className="extracao-page" component="form" autoComplete="off">
        {mensagem && <Typography className="extracao-mensagem">{mensagem}</Typography>}

        <Dialog
          open={openFotos}
          onClose={(event, reason) => {
            if (uploadingFotoIndex !== null || reason === "backdropClick") return;
            setOpenFotos(false);
          }}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Relatório fotográfico</DialogTitle>
          <DialogContent dividers>
            <Typography className="fotos-dialog-subtitulo">
              Cadastre as fotos e legendas que serão exibidas no anexo fotográfico.
            </Typography>

            <Box className="fotos-extracao-grid">
              {fotosDraft.map((foto, index) => (
                <Paper className="foto-extracao-card" key={foto.id || index} variant="outlined">
                  <Box className="foto-extracao-preview">
                    {foto.previewUrl || foto.url ? (
                      <img src={foto.previewUrl || foto.url} alt={foto.legenda || `Foto ${index + 1}`} />
                    ) : (
                      <AddPhotoAlternateIcon />
                    )}
                  </Box>

                  <TextField
                    size="small"
                    label="Legenda"
                    value={foto.legenda}
                    onChange={(e) => atualizarLegendaFoto(index, e.target.value)}
                    fullWidth
                  />

                  <Stack direction="row" spacing={1} justifyContent="space-between">
                    <Button component="label" size="small" variant="contained" disabled={uploadingFotoIndex !== null}>
                      {foto.arquivo ? "Selecionada" : "Imagem"}
                      <input hidden accept="image/*" type="file" onChange={(e) => selecionarImagemFoto(index, e.target.files?.[0])} />
                    </Button>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => removerImagemFoto(index)}
                      disabled={(!foto.url && !foto.previewUrl) || uploadingFotoIndex !== null}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                </Paper>
              ))}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={adicionarFotoExtra} startIcon={<AddPhotoAlternateIcon />} disabled={uploadingFotoIndex !== null}>
              Acrescentar imagem
            </Button>
            <Button onClick={() => setOpenFotos(false)} disabled={uploadingFotoIndex !== null}>Cancelar</Button>
            <Button onClick={salvarFotos} variant="contained" disabled={uploadingFotoIndex !== null}>
              {uploadingFotoIndex !== null ? "Salvando..." : "Salvar"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openFotosParecer}
          onClose={(event, reason) => {
            if (uploadingFotoIndex !== null || reason === "backdropClick") return;
            setOpenFotosParecer(false);
            setParecerFotoIndex(null);
          }}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Fotos do parecer técnico</DialogTitle>
          <DialogContent dividers>
            <Typography className="fotos-dialog-subtitulo">
              Estas fotos serão exibidas no relatório fotográfico antes das fotos gerais, seguindo a ordem dos locais cadastrados no parecer.
            </Typography>

            <Box className="fotos-extracao-grid">
              {fotosParecerDraft.map((foto, index) => (
                <Paper className="foto-extracao-card" key={foto.id || index} variant="outlined">
                  <Box className="foto-extracao-preview" sx={{ "& img": { objectFit: "contain" } }}>
                    {foto.previewUrl || foto.url ? (
                      <img src={foto.previewUrl || foto.url} alt={foto.legenda || `Foto ${index + 1}`} />
                    ) : (
                      <AddPhotoAlternateIcon />
                    )}
                  </Box>

                  <TextField
                    size="small"
                    label="Legenda"
                    value={foto.legenda}
                    onChange={(e) => atualizarLegendaFotoParecer(index, e.target.value)}
                    fullWidth
                  />

                  <Stack direction="row" spacing={1} justifyContent="space-between">
                    <Button component="label" size="small" variant="contained" disabled={uploadingFotoIndex !== null}>
                      {foto.arquivo ? "Selecionada" : "Imagem"}
                      <input hidden accept="image/*" type="file" onChange={(e) => selecionarImagemFotoParecer(index, e.target.files?.[0])} />
                    </Button>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => removerImagemFotoParecer(index)}
                      disabled={(!foto.url && !foto.previewUrl) || uploadingFotoIndex !== null}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                </Paper>
              ))}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={adicionarFotoParecerExtra} startIcon={<AddPhotoAlternateIcon />} disabled={uploadingFotoIndex !== null}>
              Acrescentar imagem
            </Button>
            <Button
              onClick={() => {
                setOpenFotosParecer(false);
                setParecerFotoIndex(null);
              }}
              disabled={uploadingFotoIndex !== null}
            >
              Cancelar
            </Button>
            <Button onClick={salvarFotosParecer} variant="contained" disabled={uploadingFotoIndex !== null}>
              {uploadingFotoIndex !== null ? "Salvando..." : "Salvar"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openConfirmarCancelamento}
          onClose={() => {
            setNavegacaoPendente(null);
            setOpenConfirmarCancelamento(false);
          }}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Cancelar alterações</DialogTitle>
          <DialogContent dividers>
            <Typography>Ao confirmar você perderá todas as alterações. Deseja continuar?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              setNavegacaoPendente(null);
              setOpenConfirmarCancelamento(false);
            }}>
              Não
            </Button>
            <Button color="error" variant="contained" onClick={confirmarCancelarAlteracoes}>
              Sim, cancelar
            </Button>
          </DialogActions>
        </Dialog>

        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography fontWeight={700} mb={2}>DADOS DO RELATÓRIO</Typography>

          <Box display="grid" gridTemplateColumns={{ xs: "1fr", md: "repeat(4, 1fr)" }} gap={2}>
            <TextField label="Data" value={formatarDataBR(relatorio.dataRelatorio)} size="small" InputProps={{ readOnly: true }} />
            <TextField label="Cliente" value={relatorio.cliente || "-"} size="small" InputProps={{ readOnly: true }} />
            <TextField label="Empreendimento/Obra" value={relatorio.obra || "-"} size="small" InputProps={{ readOnly: true }} />
            <TextField label="Código" value={relatorio.codigo || "-"} size="small" InputProps={{ readOnly: true }} />
            <TextField label="Segmento" value={relatorio.segmento || "-"} size="small" InputProps={{ readOnly: true }} />
            <TextField label="Local" value={relatorio.local || "-"} size="small" InputProps={{ readOnly: true }} sx={{ gridColumn: { xs: "auto", md: "span 3" } }} />
          </Box>
        </Paper>

        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography fontWeight={700} mb={2}>TEXTOS DO RELATÓRIO</Typography>
          <Stack spacing={2}>
            <Typography fontWeight={700}>1. Objetivo</Typography>
            <TextField value={relatorio.objetivo || ""} onChange={(e) => atualizarCampo("objetivo", e.target.value)} multiline minRows={4} fullWidth />
            <Typography fontWeight={700}>2. Metodologia</Typography>
            <TextField value={relatorio.metodologia || ""} onChange={(e) => atualizarCampo("metodologia", e.target.value)} multiline minRows={5} fullWidth />
            <Typography fontWeight={700}>{numeroParecer}. Parecer técnico</Typography>
            <Typography fontWeight={700}>{numeroIdentificacaoParecer}. Identificação e Tratamento de Não conformidades</Typography>
            <TextField value={removerNumeracaoTitulo(relatorio.parecerTitulo)} onChange={(e) => atualizarCampo("parecerTitulo", removerNumeracaoTitulo(e.target.value))} fullWidth />
            <Typography fontWeight={700}>Descrição do parecer técnico</Typography>
            <TextField value={relatorio.parecerDescricao || ""} onChange={(e) => atualizarCampo("parecerDescricao", e.target.value)} multiline minRows={4} fullWidth />
          </Stack>
        </Paper>

        <Paper sx={{ p: 2, mb: 3 }}>
          <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "stretch", sm: "center" }} spacing={2} mb={2}>
            <Typography fontWeight={700}>PARECER TÉCNICO</Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
              <Button startIcon={<AddIcon />} variant="contained" onClick={adicionarLocalParecer}>
                Acrescentar local
              </Button>
            </Stack>
          </Stack>

          <Box sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 980 }}>
              <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                <TableRow>
                  <TableCell sx={{ width: 180, textAlign: "center" }}>Local</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Não conformidade</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>Tratamento da não conformidade</TableCell>
                  <TableCell sx={{ width: 110, textAlign: "center" }}>Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(relatorio.parecerItens || []).map((item, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ verticalAlign: "top" }}>
                      <TextField size="small" value={item.local || ""} onChange={(e) => atualizarLinhaParecer(index, "local", e.target.value)} sx={inputTabelaSx} fullWidth />
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "top" }}>
                      <TextField size="small" value={item.naoConformidade || ""} onChange={(e) => atualizarLinhaParecer(index, "naoConformidade", e.target.value)} multiline minRows={4} sx={inputTabelaSx} fullWidth />
                    </TableCell>
                    <TableCell sx={{ verticalAlign: "top" }}>
                      <TextField size="small" value={item.tratamento || ""} onChange={(e) => atualizarLinhaParecer(index, "tratamento", e.target.value)} multiline minRows={4} sx={inputTabelaSx} fullWidth />
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Fotos deste local">
                        <IconButton size="small" onClick={() => abrirCadastroFotosParecer(index)}>
                          <AddPhotoAlternateIcon color={(item.fotosParecer || []).some((foto) => foto?.url) ? "success" : "primary"} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Acrescentar não conformidade/melhoria">
                        <IconButton size="small" onClick={() => adicionarLinhaParecerNoLocal(index)}>
                          <AddIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Remover linha">
                        <span>
                          <IconButton size="small" onClick={() => removerLinhaParecer(index)} disabled={(relatorio.parecerItens || []).length <= 1}>
                            <DeleteIcon color="error" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Paper>

        <Paper sx={{ p: 2, mb: 3 }}>
          <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "stretch", sm: "center" }} spacing={2} mb={2}>
            <Typography fontWeight={700}>NOTAS E CONSIDERAÇÕES</Typography>
            <Button startIcon={<AddIcon />} variant="outlined" onClick={adicionarNota}>Acrescentar nota</Button>
          </Stack>

          <Stack spacing={2}>
            {(relatorio.notasParecer || []).map((nota, index) => (
              <Stack direction="row" spacing={1} key={index} alignItems="flex-start">
                <TextField label={`Nota ${index + 1}`} value={nota} onChange={(e) => atualizarNota(index, e.target.value)} multiline minRows={2} fullWidth />
                <IconButton size="small" onClick={() => removerNota(index)}>
                  <DeleteIcon color="error" />
                </IconButton>
              </Stack>
            ))}
            <Typography fontWeight={700}>{tituloBoasPraticas}</Typography>
            <TextField value={relatorio.boasPraticas || ""} onChange={(e) => atualizarCampo("boasPraticas", e.target.value)} multiline minRows={4} fullWidth />
            <Typography fontWeight={700}>{numeroResultadoAceitacao}. Resultado/Aceitação</Typography>
            <TextField value={relatorio.resultadoAceitacao || ""} onChange={(e) => atualizarCampo("resultadoAceitacao", e.target.value)} multiline minRows={4} fullWidth />
            <Typography fontWeight={700}>{numeroAnexos}. Anexos</Typography>
            <TextField value={relatorio.anexos || ""} onChange={(e) => atualizarCampo("anexos", e.target.value)} multiline minRows={3} fullWidth />
            <Typography fontWeight={700}>{numeroConsideracoesFinais}. Considerações finais</Typography>
            <TextField value={relatorio.consideracoesFinais || ""} onChange={(e) => atualizarCampo("consideracoesFinais", e.target.value)} multiline minRows={5} fullWidth />
          </Stack>
        </Paper>
      </Box>
    </>
  );
}
